import themeDefault from './default.json'
import themeOne from './themeOne.json'
import { PROJECT_THEME } from '@/utils'

export function themeData(key: string) {
  if (!key) return ''
  const themes = {
    themeDefault,
    themeOne,
  }
  const theme = themes[PROJECT_THEME] || themes['themeDefault']
  return theme[key] || ''
}
